__webpack_require__.p = "https://B2BMiniBobMFE-dev.shipbob.dev/";